<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />
		<div v-html="node.options.content"></div>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';

export default {
	name: 'NodeHtml',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
	},
	computed: {},
	methods: {
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style lang="scss">
.node-anchor {
	width: 100%;
	text-align: center;
	background: #f5f5f5;
	border: 1px solid #ddd;
	border-radius: 3px;
	padding: .3rem;
	color: #cccccc;
}
</style>
